import { HudPanel } from './hud-panel';

export function ScanPrompt() {
  return (
    <main class="flex min-h-screen items-center justify-center p-6">
      <HudPanel class="max-w-md text-center">
        <h1 class="hud-mono text-lg font-semibold uppercase tracking-[0.22em] text-ink">Heligraph</h1>
        <p class="hud-mono mt-1 text-[0.5938rem] uppercase tracking-[0.3em] text-faint">Mission control</p>
        <p class="mt-4 text-sm text-muted">
          Scan the QR code shown in your terminal with your phone, or paste the full pairing URL
          (including the <code class="hud-mono text-ink">#</code> hash) into the address bar.
        </p>
      </HudPanel>
    </main>
  );
}
